import * as requestFromServer from "./registrationDataCrud";
import {registrationDataSlice, callTypes} from "./registrationDataSlice";

const {actions} = registrationDataSlice;

const getRegistrationDataList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  return requestFromServer
    .findRegistrationData(queryParams)
    .then(response => {
      const {errorCode, data: {totalUsersCount: totalCount, pageCount, requestedPageNumber, usersList, ...rest}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: [usersList, {...rest}]
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "Can't find customers";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};

export const exportRegistrationDataFileAction = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getRegistrationDataFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.usersList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = "Can't get file!";
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getRegistrationData = getRegistrationDataList(actions.registrationDataFetched);
export const getNextRegistrationData = getRegistrationDataList(actions.registrationDataAppended);
